<template>
    <v-layout row wrap>
        <!-- <v-flex xs12 sm20 md50>
            <v-radio-group v-model="selectedNV" class="center-radio-buttons">
                <v-radio label="Macchina da registrare" value="new"></v-radio>
                <v-radio label="Macchina già registrata" value="old"></v-radio>
            </v-radio-group>
        </v-flex> -->

        <v-flex xs12 sm6 md4>
            <v-combobox :label="$t('prenotazioni.label.marca')" item-value="id" item-text="nome" :items='marche'
                :required="required" v-model="marcaSelezionata" @change="marcaChanged" v-if="selectedNV !== 'new'"
                v-bind="$attrs" />
        </v-flex>

        <v-flex xs12 sm6 md4>
            <v-combobox :label="$t('prenotazioni.label.modello')" item-value="id" item-text="nome" :items="modelliMac"
                :required="required" v-bind="$attrs" :disabled="!marcaSelezionata" v-model="modelloSelezionato"
                v-if="selectedNV !== 'new'" @change="modelloChanged"/>
        </v-flex>

        <v-flex xs12 sm6 md4>
            <v-combobox :label="$t('prenotazioni.label.num_serie')" item-value="id" item-text="nome" :items="numerSerie"
                :required="required" :disabled="!this.modelloSelezionato" v-model="numSerieSelezionato" @change="numSerieChanged" v-if="selectedNV !== 'new'" v-bind="$attrs" />
        </v-flex>

        <!-- <v-flex xs12 sm6 md4>
            <text-field :label="$t('prenotazioni.label.marca')" v-if="selectedNV !== 'old'" />
        </v-flex>

        <v-flex xs12 sm6 md4>
            <text-field :label="$t('prenotazioni.label.modello')" v-if="selectedNV !== 'old'" />
        </v-flex>

        <v-flex xs12 sm6 md4>
            <text-field :label="$t('prenotazioni.label.numero_serie')" v-if="selectedNV !== 'old'" />
        </v-flex> -->
    </v-layout>
</template>

<style>
.center-radio-buttons {
    display: flex;
    justify-content: center;
}
</style>

<script>
export default {
    inheritAttrs: false,
    name: 'MacchinaSelect',
    props: {
        required: Boolean,
        // L'id agricoltore viene passato da ../PrenotazioneDialog.vie
        idAgricoltore: Number,
        marca: String,
        modello: String,
        numero_serie: String
    },
    data() {
        return {
            loading: false,
            // Array di tutte le macchine
            allMacchine: [],
            // Tutte le marche delle macchine
            marche: [],
            // Tutti i modelli delle macchine
            modelliMac: [],
            // Tutti i numeri di serie delle macchine
            numerSerie: [],
            // Seleziona di default nel radio button una macchina già salvata
            selectedNV: 'old',
            // Salvo cosa viene selezionato per gli excract
            marcaSelezionata: '',
            modelloSelezionato: '',
            numSerieSelezionato: ''
        }
    },
    // Quando viene create l'istanza viene chiamata created
    //created() {
    //    (async () => {
    //        //  Caricamento i dati inziale
    //        await this.getAllMacchine()
    //    })().catch(e => {
    //        this.$snackbar.showServerError(e)
    //    })
    //},
    // Watch osserva cambiamenti usato qui solo per vedere se l'agricoltore viene cambiato/selezionato
    watch: {
        async idAgricoltore(newValue, oldValue) {
            // Pulisco gli elementi dentro le combobox e faccio partire l'estrazione delle marche
            this.marche = []
            this.modelliMac = []
            this.numerSerie = []
            
            await this.getAllMacchineAgricoltore()
            this.extractMarcaArray()
           
        },
        marca()
        {
            this.marcaSelezionata = this.marca;

            if(this.marcaSelezionata != null)
                this.marcaChanged();
        },
        modello()
        {
            this.modelloSelezionato = this.modello;

            if(this.modelloSelezionato != null)
                this.modelloChanged();
        },
        numero_serie()
        {
            this.numSerieSelezionato = this.numero_serie;
        }
    },
    methods: {
        async getAllMacchine() {
            try {
                // Prende tutte le macchine
                this.allMacchine = await this.$api.macchine.getAll()
                // Rimuove le cose non necessarie (tutto cio che non è contenuto anche nel database) e recupera solo i dati
                this.allMacchine = this.allMacchine.data
            } catch (error) {
                console.error(error)
            }
        },
        async getAllMacchineAgricoltore() {
            if (this.idAgricoltore != null){
                try {
                    // Prende tutte le macchine
                    this.allMacchine = await this.$api.macchine.getForCliente(this.idAgricoltore)
                    // Rimuove le cose non necessarie (tutto cio che non è contenuto anche nel database) e recupera solo i dati
                    this.allMacchine = this.allMacchine.data
                } catch (error) {
                    console.error(error)
                }
            }
        },
        extractMarcaArray() {
            this.marche = []
            this.numerSerie = []
            // Per ogni macchina se l'id_agricoltore della macchine è uguale a quello inserito dall'utente faccio .push (aka .add) sul array delle marche
            this.allMacchine.forEach((element) => {
                if (element.id_agricoltore === this.idAgricoltore) 
                { 
                    this.marche.push(element.marca); 
                }
            })
        },
        marcaChanged() {
            this.modelliMac = [];
            this.numerSerie = [];

            this.modelloSelezionato = null;
            this.numSerieSelezionato = null;

            // Per ogni macchina se l'id_agricoltore e la marca della macchine sono uguali a quello inserito dall'utente faccio .push (aka .add) sul array delle modelli
            this.allMacchine.forEach((element) => {
                if (element.marca === this.marcaSelezionata && element.id_agricoltore === this.idAgricoltore) 
                { 
                    this.modelliMac.push(element.modello);
                }
                this.$emit('update:marca', this.marcaSelezionata);
            })
            this.$emit('update:marca', this.marcaSelezionata);
        },
        modelloChanged() {
            this.numerSerie = []

            this.numSerieSelezionato = null;

            // Stesso cosa di prima ma controllo anche modello
            this.allMacchine.forEach((element) => {
                if (element.id_agricoltore === this.idAgricoltore && element.marca === this.marcaSelezionata && element.modello === this.modelloSelezionato) 
                { 
                    this.numerSerie.push(element.numero_serie);
                }
                this.$emit('update:modello', this.modelloSelezionato); // Emetti evento per aggiornare il modello
            })
            this.$emit('update:modello', this.modelloSelezionato);
        },
        numSerieChanged() {
            this.$emit('update:numero_serie', this.numSerieSelezionato); // Emetti evento per aggiornare il numero di serie
        }
    }
}
</script>
